module.exports = __webpack_public_path__ + "static/media/horoscope-icon-2.2e679b62.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-2.png
// module id = 1528
// module chunks = 0